// AI Generated Component
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

interface TabOption {
    value: string;
    name: string;
}

@Component({
    selector: 'page-details-sections-tabs',
    standalone: false,
    template: `
        <ul class="page-details-tab list-inline max-width d-flex align-items-stretch">
            <li [class]="{'active': tab === tabOption.value}"
                [attr.data-test]="'tab-' + tabOption.name"
                role="menuitem"
                (click)="changeTab(tabOption.value)"
                monEventTrigger="actionTrigger"
                [monEventParams]="{action: 'page-details-tab-'+tabOption.value+'-section-btn'}"
                [attr.aria-label]="tabOption.name"
                class="px-2 align-self-center text-link cursor-pointer"
                *ngFor="let tabOption of options">
                {{ tabOption.name }}
            </li>
            <div class="d-flex ml-auto flex-wrap page-details-tab-content">
                <ng-content></ng-content>
            </div>
        </ul>
    `,
})
export class PageDetailsSectionsTabsComponent implements OnInit {
    @Input() options: TabOption[] = [];
    @Input() tab!: string;
    @Output() onTabChange = new EventEmitter<{ tab: string }>();

    constructor () {}

    ngOnInit (): void {
        this.options = this.options || [];
    }

    changeTab (tab: string): void {
        this.onTabChange.emit({ tab: tab });
    }
}
